import React from "react"
import styled from "@emotion/styled"
import { Box, Flex } from "@rebass/grid/emotion"
import { TextElementMen } from "@nutrafol/nutrafol-ui-kit/dist/TextElementMen"

const ContentWrapContainer = styled(Flex)`
  text-align: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  margin: 0 auto;
  max-width: 347px;
  @media (max-width: 767px) {
    //padding: 37vw 0 0 0;
  }
  @media (min-width: 768px) and (max-width: 1023px) {
    max-width: 688px;
  }
  @media (min-width: 1024px) {
    max-width: 900px;
    .subheading {
      font-size: 24px !important;
      line-height: 33.6px !important;
    }
  }
  @media (min-width: 1440px) {
    //padding: 0 64px;
    max-width: 1400px;
    h1 {
      font-size: 88px !important;
      line-height: 79.2px !important;
    }
  }
`

const ContentSection = styled(Flex)`
  margin: 0 auto;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  @media (min-width: 1800px) {
    max-width: 1488px;
  }
`

const Banner = ({ data }) => {
  const subheading = data?.subheading
  const BannerWrap = styled.div`
    position: relative;
    overflow-x: hidden;
    margin-top: 99px;
    background-repeat: no-repeat;
    background-image: url(${data.mobileImage});
    background-size: cover;
    background-position: 100% 50%;
    height: 92dvw;
    padding-top: 54px;
    @media (min-width: 768px) {
      height: 47dvw;
      background-image: url(${data.tabletImage});
      margin-top: 22px;
      padding-top: 117px;
    }
    @media (min-width: 1024px) {
      margin-top: 0;
    }
    @media (min-width: 1440px) {
      height: 534px;
      background-image: url(${data.desktopImage});
    }
    @media (min-width: 1800px) {
      height: 700px;
    }
  `
  return (
    <BannerWrap>
      <ContentSection>
        <ContentWrapContainer>
          {subheading ? (
            <Box pb={[8]}>
              <TextElementMen
                element="p"
                text={subheading}
                className={
                  "mono--medium text-men-base-default text-center subheading uppercase"
                }
              />
            </Box>
          ) : null}
          <Box>
            <TextElementMen
              element="h1"
              text={data.heading}
              className={"title--large text-men-base-default text-center"}
            />
          </Box>
        </ContentWrapContainer>
      </ContentSection>
    </BannerWrap>
  )
}

export default Banner
